export const FETCH_GIFT_CARD_DATA = "FETCH_GIFT_CARD_DATA";
